<template>
	<div class="box clearF">
		<div
			class="projects-left"
			:style="{ 'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}` }"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
		>
			<div class="projects-head clearF">
				<div class="projects-head-l">
					<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{
						contentData.title_en
					}}</h1>
					<p>{{ contentData.title_cn }}</p>
				</div>
				<div class="projects-head-r clearF">
					<img
						src="../assets/project-back-night.svg"
						v-if="dayNightMode == 'day'"
						@click="goBack"
						alt
					/>
					<img
						src="../assets/project-back-day.svg"
						v-if="dayNightMode == 'night'"
						@click="goBack"
						alt
					/>
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">CLIENT</p>
				</div>
			</div>

			<div class="projects-nav clearF" style="padding-bottom:22px;margin-top:22px;">
				<ul class="projects-nav-ul">
					<li class="projects-nav-en">CONTRIBUTIONS</li>
					<li v-for="(item, index) in contentData.contr" :key="index">{{ item }}</li>
					<li class="projects-nav-en" style="padding:4px 0  2px 0;">POSITIONING</li>
					<li v-for="(item, index) in contentData.posit" :key="'posit' + index">{{ item }}</li>
					<li class="projects-nav-en" style="padding:7px 0 0 3px;margin-bottom:4px;">SLOGAN</li>
					<li v-for="(item, index) in contentData.alogan" :key="'alogan' + index">{{ item }}</li>
				</ul>
				<div class="projects-nav-time">
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">TIME</p>
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{
						contentData.addtime
					}}</p>
				</div>
			</div>

			<div class="projects-text" v-for="(item, index) in contentData.content" :key="index">
				<div class="projects_title" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{
					item.name
				}}</div>
				<div v-html="item.content"></div>
			</div>

			<div class="projects-next clearF">
				<div class="projects-next-arrow" @click="goBack">
					<img src="../assets/project-back-night.svg" v-if="dayNightMode == 'day'" alt />
					<img src="../assets/project-back-day.svg" v-if="dayNightMode == 'night'" alt />
				</div>
				<div
					class="projects-next-button"
					@mouseenter="isHovering = true"
					@mouseleave="isHovering = false"
					:class="{
						'projects-next-button-hover-day': isHovering && dayNightMode == 'day',
						'projects-next-button-hover-night': isHovering && dayNightMode == 'night',
					}"
				>
					<button
						@click="goAssign(1)"
						v-if="listIndex < listData.length - 1"
						:style="{
							border: `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
						}"
					>
						<span
							:style="{
								color:
									dayNightMode == 'day'
										? isHovering
											? '#fff'
											: '#000'
										: isHovering
										? '#000'
										: '#fff',
							}"
							>NEXT PROJECTS</span
						>
					</button>
				</div>
			</div>
		</div>

		<div
			class="projects-right"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
			:style="{
				'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
			}"
		>
			<ul class="projects-right-ul">
				<li
					class="projects-right-li"
					v-for="(item, index) in contentData.video"
					:key="'video' + index"
				>
					<video :src="item.image" controls></video>
				</li>
				<li
					class="projects-right-li"
					@click="showSwiper(1, index)"
					v-for="(item, index) in contentData.image"
					:key="'image' + index"
				>
					<img :src="item.image" alt />
				</li>
			</ul>
		</div>

		<!-- 轮播图 -->
		<transition name="fade">
			<div class="projects-pic" v-if="swiperBool">
				<div class="projects-pic-back"></div>
				<div class="projects-pic-cloes clearF" @click="showSwiper(0)">
					<img src="../assets/project-close.png" alt />
				</div>

				<div class="projects-pic-swiper">
					<div class="swiper-container">
						<div class="projects-pic-box swiper-wrapper">
							<div
								class="projects-pic-box-i swiper-slide swiper-no-swiping"
								v-for="(item, index) in contentData.image"
								:key="index"
							>
								<img :src="item.image" alt />
							</div>
						</div>
					</div>
				</div>

				<div
					class="projects-arrows-left"
					@mouseenter="mouseEnter('l')"
					@mouseleave="mouseLeave('l')"
				>
					<img
						src="../assets/pic-arrows-l.png"
						class="projects-arrows-left-i c-projects-arrows-left-i"
						alt
					/>
					<div class="c-back-close" @click="showSwiper(0)"></div>
				</div>
				<div
					class="projects-arrows-right"
					@mouseenter="mouseEnter('r')"
					@mouseleave="mouseLeave('r')"
				>
					<img
						src="../assets/pic-arrows-r.png"
						class="projects-arrows-right-i c-projects-arrows-right-i"
						alt
					/>
					<div class="c-back-close" @click="showSwiper(0)"></div>
				</div>

				<div class="c-back-img">
					<div class="c-back-img-rev">
						<div
							class="c-back-img-l c-projects-arrows-left-i"
							@mouseenter="mouseEnter('l')"
							@mouseleave="mouseLeave('l')"
						></div>
						<div
							class="c-back-img-r c-projects-arrows-right-i"
							@mouseenter="mouseEnter('r')"
							@mouseleave="mouseLeave('r')"
						></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	export default {
		data() {
			return {
				swiperBool: false,
				contentID: '', //文章id
				contentData: '', //文章内容
				listData: '', //列表内容

				listIndex: -2, //索引

				dayNightMode: this.$store.state.dayNightMode,
				isHovering: false,
			};
		},
		async created() {
			this.contentID = this.$store.state.projectsContBz;
			window.history.replaceState({}, '', window.location.href + '-' + this.contentID);
			await this.getContentData();
			let res = await this.$post('api/home/projectstype');
			let bz = res.data.find((item) => item.id == this.contentData.tid).bz;
			this.getListData(bz);
		},
		mounted() {},
		watch: {
			'$store.state.dayNightMode': function() {
				this.dayNightMode = this.$store.state.dayNightMode;
			},
		},
		methods: {
			mouseLeave(type) {
				if (type == 'l') {
					document.querySelector('.projects-arrows-left-i').style.cssText = 'opacity:0';
				} else {
					document.querySelector('.projects-arrows-right-i').style.cssText = 'opacity:0';
				}
			},

			mouseEnter(type) {
				if (type == 'l') {
					document.querySelector('.projects-arrows-left-i').style.cssText = 'opacity:1';
				} else {
					document.querySelector('.projects-arrows-right-i').style.cssText = 'opacity:1';
				}
			},

			// 设置图片蒙版
			picMasking() {
				const activeSlide = document.querySelector('.swiper-slide-active');
				console.log('activeSlide', activeSlide);
				if (!activeSlide) return;

				const firstChild = activeSlide.firstChild;
				console.log('firstChild', firstChild);
				if (!firstChild) return;

				console.log('dom', firstChild);
				const w = firstChild.offsetWidth;
				const h = firstChild.offsetHeight;

				const picBack = document.querySelector('.projects-pic-back');
				if (!picBack) return;

				const top = (picBack.offsetHeight - firstChild.offsetHeight) / 2;

				const backImg = document.querySelector('.c-back-img');
				if (!backImg) return;

				backImg.style.cssText = `width:${w}px;height:${h}px;top:${top}px;`;
			},

			// 跳转至指定内容
			goAssign(num) {
				if (num == 0) {
					// 上一页
					this.listIndex--;
				} else {
					// 下一页
					this.listIndex++;
				}
				let bz = this.listData[this.listIndex].bz;
				this.contentID = bz;
				this.contentData = '';
				this.getContentData();
			},

			// 获取列表的内容
			getListData(id) {
				this.$post('api/home/ProjectsList', { id }).then((res) => {
					this.listData = res.data;
					this.listIndex = this.listData.findIndex((item) => item.bz == this.contentID) || 0;
				});
			},

			// 获取当前文章内容
			async getContentData() {
				try {
					let res = await this.$post('api/home/ProjectsInfo', {
						id: this.contentID,
					});
					let time = new Date(parseInt(res.data.addtime * 1000));
					this.contentData = res.data;
					this.contentData.addtime = time.getFullYear() + '.' + (parseInt(time.getMonth()) + 1);
				} catch (error) {
					console.log(error);
				}
			},

			// 返回上一页
			goBack() {
				this.$router.go(-1); //返回上一层
			},
			// 显示/隐藏轮播图
			showSwiper(type, index) {
				let _this = this;
				// type = 0 关闭 type = 1打开
				type == 0
					? (this.swiperBool = false)
					: (() => {
							this.swiperBool = true;
							this.$nextTick(() => {
								var swiper = new Swiper('.swiper-container', {
									loop: true,
									navigation: {
										nextEl: '.c-projects-arrows-right-i',
										prevEl: '.c-projects-arrows-left-i',
									},
									on: {
										slideChangeTransitionStart: function() {
											_this.picMasking();
										},
									},
									// noSwipingClass: "stop-swiping"
								});
								swiper.slideTo(index + 1, 0, false);
								_this.picMasking();
							});
					  })();
			},
		},
	};
</script>

<style lang="less" scoped>
	@import '../../node_modules/swiper/css/swiper.css';
	@font-face {
		font-family: SourceBold;
		src: url(../../public/font/SourceHanSansCN-Bold.otf);
	}
	@font-face {
		font-family: Medium;
		src: url(../../public/font/SourceHanSansCN-Medium.otf);
	}
	@font-face {
		font-family: nexalight;
		src: url(../../public/font/NexaLight.otf);
	}
	@font-face {
		font-family: NexaBold;
		src: url(../../public/font/NexaBold.otf);
	}
	.box {
		position: relative;
	}
	.projects-right {
		height: 100vh;
		overflow: auto;
	}
	.projects-right::-webkit-scrollbar {
		width: 0px;
	}
	.projects-left::-webkit-scrollbar {
		width: 0px;
	}

	.projects-left {
		width: 50%;
		height: 100vh;
		float: left;
		overflow: auto;
		padding: 0.1823rem 0.1563rem 0.9896rem 0.1563rem;
	}

	.projects-head {
		padding-bottom: 0.1146rem;
		border-bottom: 1px solid #808080;
	}

	.projects-head-l {
		float: left;
		p {
			font-size: 0.2031rem;
			font-family: SourceBold;
		}
	}

	.projects-head-r {
		float: right;
		img {
			width: 57px;
			height: 40px;
			display: block;
			float: right;
			cursor: pointer;
		}
		p {
			font-size: 24px;
			color: #231815;
			margin-top: 22px;
			font-family: nexalight;
			float: right;
			width: 100%;
			text-align: right;
		}
	}

	.projects-nav {
		position: relative;
		margin-top: 40px;
		padding-bottom: 40px;
		border-bottom: 1px solid #808080;
	}

	.projects-nav-ul {
		float: left;
		// margin-bottom: 15px;
		li {
			font-size: 28px;
			margin-bottom: 6.8px;
			font-family: Medium;
		}
		li:first-child {
		}
	}
	.projects_title {
		font-family: Medium;
		font-size: 28px;
		line-height: 48px;
		color: #231815;
		margin-bottom: 2px;
	}
	.projects-nav-ul {
		.projects-nav-en {
			font-size: 25px;
			font-family: nexalight;
			margin-bottom: 5px;
		}
		.projects-nav-en:first-child {
			margin-top: 0;
		}
	}

	.projects-nav-time {
		float: right;
		text-align: right;
		position: absolute;
		bottom: 33px;
		right: 0;
		p {
			font-size: 31px;
			color: #231815;
			font-family: NexaBold;
		}
		p:first-child {
			font-size: 25px;
			margin-bottom: 5px;
			font-family: nexalight;
		}
	}

	.projects-text {
		margin-top: 18px;
		margin-bottom: 18px;
	}

	.projects-next {
		margin-top: 40px;
	}

	.projects-next-arrow {
		float: left;
		cursor: pointer;
		img {
			width: 57px;
			height: 39px;
		}
	}

	.projects-next-button {
		float: right;
		button {
			display: block;
			width: 232px;
			height: 41px;
			background: none;
			border: 1px solid #000;
			font-size: 25px;
			color: #231815;
			transition: all 0.3s;
		}
	}
	.projects-next-button-hover-day {
		color: #ffffff;
		background: #231815;
		border: 2px solid #231815;
	}
	.projects-next-button-hover-night {
		color: #000;
		background: #fff;
		border: 2px solid #fff;
	}

	.projects-right {
		width: 50%;
		padding: 0.1927rem 0.1563rem 0 0.1563rem;
		float: left;
		border-left: 1px solid #000;
	}

	.projects-right-ul {
	}

	.projects-right-li {
		// height: 458px;
		margin-bottom: 20px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #e8e8e8;
		img {
			max-width: none;
			// height: 110%;
			width: 100%;
		}
		video {
			width: 100%;
		}
	}

	.projects-pic {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		height: 100vh;
	}

	.projects-pic-back {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		height: 100vh;

		background: rgba(0, 0, 0, 0.9);
	}

	.projects-pic-cloes {
		cursor: pointer;
		position: relative;
		z-index: 4;
		float: right;
		margin: 41px 39px 0 0;
		img {
			width: 48px;
			height: 48px;
			transform: rotate(0deg);
			transition: 0.3s all;
		}
	}

	.projects-pic-cloes:hover img {
		transform: rotate(90deg);
	}

	.projects-pic-swiper {
		width: 100%;
		height: 70%;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		text-align: center;
		display: flex;
		img {
			// height: 110%;
		}
		overflow: hidden;
	}

	.projects-arrows-left,
	.projects-arrows-right {
		z-index: 3;
		position: absolute;
		width: 50%;
		height: 100%;
		top: 0;
		right: 0;
		bottom: 0;
		margin: auto 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 50px;
		outline: none;
		img {
			opacity: 0;
			transition: 0.5s all;
			width: 61px;
			height: 51px;
			cursor: pointer;
			outline: none;
			position: absolute;
			top: 0;
			bottom: 0;
			margin: auto 0;
			left: 50px;
			z-index: 4;
		}
	}

	.projects-arrows-right {
		img {
			left: auto;
			right: 50px;
		}
	}

	.projects-arrows-left:hover img {
		opacity: 1;
	}
	.projects-arrows-right:hover img {
		opacity: 1;
	}

	.projects-arrows-left {
		left: 0;
		justify-content: flex-start;
		text-align: left;
		padding-left: 50px;
		padding-right: 0;
	}

	.projects-pic-box {
		width: 100%;
		height: 100%;
		// display: inline-block;
	}

	.projects-pic-box-i {
		// position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			max-width: 80%;
			max-height: 650px;
		}
	}

	.c-back-close {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 3;
	}

	.c-back-img {
		position: absolute;
		right: 0;
		left: 0;
		margin: 0 auto;
		z-index: 10;
	}

	.c-back-img-rev {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.c-back-img-l,
	.c-back-img-r {
		width: 50%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.c-back-img-r {
		left: auto;
		right: 0;
	}

	.c-projects-arrows-left-i,
	.c-projects-arrows-right-i {
		outline: none;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
